import { render } from "./MarketAnalysis.vue?vue&type=template&id=95da9594&scoped=true"
import script from "./MarketAnalysis.vue?vue&type=script&lang=js"
export * from "./MarketAnalysis.vue?vue&type=script&lang=js"

import "./MarketAnalysis.vue?vue&type=style&index=0&id=95da9594&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95da9594"]])

export default __exports__